
export type NotificationItemTarget = {
  /** @nullable */
  targetId?: number | null;
  /** @nullable */
  targetType?: string | null;
};
